import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for icon button style.
 *
 * @returns {ThemeStyle}
 */
export const getMuiIconButtonStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      padding: 0,
      color: theme.palette.icon.primary,

      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: 'transparent',
      },
    },
  };
};
